import { createContext, useState, useContext, useEffect } from "react";
import useContacts from "../api/contacts";

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const { getCompanyContacts } = useContacts();

  const fetchUnreadMessagesCount = async () => {
    try {
      const inboxData = await getCompanyContacts({ status: "Inbox" });
      const unreadCount = inboxData?.filter(msg => !msg.read)?.length || 0;
      setUnreadMessagesCount(unreadCount);
    } catch (error) {
      console.error("Error fetching unread messages count:", error);
    }
  };

  useEffect(() => {
    fetchUnreadMessagesCount();
  }, []);

  return (
    <MessageContext.Provider value={{ unreadMessagesCount, setUnreadMessagesCount, fetchUnreadMessagesCount }}>
      {children}
    </MessageContext.Provider>
  );
};

export const useMessages = () => useContext(MessageContext);